import { Episode, EpisodesLoadingState } from '../types/Episode';
import { getFeaturedEpisodes } from '../services/episodesLoader';
import { useAsyncData } from './useAsyncData';

/**
 * Hook to load featured episodes only
 *
 * Usage:
 *   const { episodes, loading, error } = useFeaturedEpisodes();
 */
export function useFeaturedEpisodes(): EpisodesLoadingState {
  const { data, loading, error } = useAsyncData<Episode[]>(
    getFeaturedEpisodes,
    [],
    {
      errorMessage: 'Failed to load featured episodes',
      hmrEventName: 'episodes-updated'
    }
  );

  return {
    episodes: data ?? [],
    loading,
    error
  };
}
